const ITEMS = [
  "Independent Advice",
  "Property Sourcing",
  "Refurbishment",
  "Tenant Finding",
  "Finance & Legal",
  "Trusted Network",
];

const Strip = () => (
  <div className="flex shrink-0 items-center" aria-hidden="true">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="font-serif italic text-lg sm:text-xl text-gold-soft tracking-wide px-8 sm:px-10">
          {item}
        </span>
        <span className="text-gold text-[10px]">✦</span>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="bg-forest-deep border-y border-gold/20 py-5 overflow-hidden"
  >
    <div className="marquee-track">
      <Strip />
      <Strip />
    </div>
  </div>
);
